import React from 'react';

export function ChevronDown(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="18"
        height="10"
        viewBox="0 0 18 10"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9111 1.3776C17.3137 1.84724 17.2898 2.53847 16.8757 2.97922L16.781 3.06966L10.4318 8.51184C9.65366 9.17878 8.52603 9.21584 7.70909 8.62299L7.56828 8.51184L1.21907 3.06966C0.71588 2.63835 0.657607 1.88079 1.08891 1.3776C1.49147 0.907954 2.17822 0.825881 2.67711 1.16769L2.78097 1.24744L9.00002 6.57755L15.2191 1.24744C15.6887 0.844888 16.3799 0.868814 16.8207 1.28291L16.9111 1.3776Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
